export default __webpack_public_path__ + "static/media/esports-bg.ada381e2.webp";